import Vue from 'vue'
import VueSlider from 'vue-slider-component'

Vue.component('VueSlider', VueSlider)



// WEBPACK FOOTER //
// ./src/front/init/components/slider.js